import React, { useState, useEffect } from 'react'
import {
    Toolbar,
    Button,
    makeStyles,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@material-ui/core'
import { useGlobalStyles } from '../../../App'
import { userService } from '../../../services/user.service'
import userPermissionGroupService from '../../../services/rolePermissionGroup.service'
import userRoleService from '../../../services/userRole.service'
import TableContentLoadingSpinner from '../../shared/TableContentLoadingSpinner'
import { useHistory } from 'react-router-dom'
import { CreatePermissionGroupModal } from './CreatePermissionGroupModal'

const useStyles = makeStyles(theme => ({
    table: {
        minWidth: 750,
    },
    tableWrapper: {
        padding: theme.spacing(2),
    },
    enhancedTableToolbar: {
        width: '100%',

        '& .MuiToolbar-gutters': {
            paddingRight: 16,
        },
    },
    toolBar: {
        float: 'right',
    },
    tableSection: {
        marginTop: 25,
    },
    formControl: {
        minWidth: 120,
        maxWidth: 300,
    },
    toolbarButtons: {
        marginLeft: 'auto',
    },
}))

const headCells = [
    { id: 'id', label: 'Id' },
    { id: 'name', label: 'Name' },
    { id: 'roleType', label: 'Role Name' },
    { id: 'groupMemberCount', label: 'No. of Members' },
    { id: 'isEnabled', label: 'Is Enabled' },
]

const UserPermissionGroups = () => {
    const managedService = userService.getManagedService()
    const classes = useStyles()
    const globalClasses = useGlobalStyles()
    const [tableData, setTableData] = useState([])
    const [userRoles, setUserRoles] = useState([])
    const [isLoadingData, setIsLoadingData] = useState(true)
    const history = useHistory()

    const [
        createAccessLevelModalOpen,
        setCreatePermissionGroupModalOpen,
    ] = useState(false)

    const createPermissionGroupModalOkClickHandler = formData => {
        ;(async function createPermissionGroupAsync() {
            try {
                await userPermissionGroupService
                    .createPermissionGroup({
                        processEngineServiceId: managedService.id,
                        roleId: formData.roleId,
                        title: formData.title,
                        isEnabled: formData.isEnabled,
                    })
                    .then(() => {
                        updateTableData()
                    })
            } catch (exception) {
                console.log(exception)
            }
        })()
    }

    const updateTableData = async () => {
        try {
            setIsLoadingData(true)
            await userPermissionGroupService
                .getAllGroups(managedService.id)
                .then(result => {
                    setTableData(result)
                    setIsLoadingData(false)
                })
        } catch (exception) {
            console.log(exception)
        } finally {
            setIsLoadingData(false)
        }
    }

    const getUserRoles = async () => {
        try {
            await userRoleService.getAllRoles().then(result => {
                setUserRoles(result)
            })
        } catch (exception) {
            console.log(exception)
        } finally {
            setIsLoadingData(false)
        }
    }

    useEffect(() => {
        ;(async function updatePageTableDataAsync() {
            try {
                await updateTableData()
                await getUserRoles()
            } catch (exception) {
                console.log(exception)
            }
        })()
    }, [managedService.id])

    const EnhancedTableToolbar = () => {
        return (
            <div className={classes.enhancedTableToolbar}>
                <Toolbar>
                    <Button
                        className={classes.toolbarButtons}
                        data-testid='add-button'
                        onClick={() => setCreatePermissionGroupModalOpen(true)}
                        variant='contained'
                        color='secondary'>
                        Add
                    </Button>
                </Toolbar>
            </div>
        )
    }

    const getTableContent = () => {
        if (isLoadingData) {
            return <TableContentLoadingSpinner />
        }

        return tableData.map(row => (
            <TableRow>
                <TableCell>{row.id}</TableCell>
                <TableCell>{row.groupDescription}</TableCell>
                <TableCell>{row.roleName}</TableCell>
                <TableCell>{row.groupMemberCount}</TableCell>
                <TableCell>{row.isEnabled ? 'Yes' : 'No'}</TableCell>
                <TableCell align='right'>
                    <Button
                        variant='contained'
                        color='secondary'
                        onClick={() => {
                            history.push(`rolepermissiongroup/${row.id}`)
                        }}>
                        Edit
                    </Button>
                </TableCell>
            </TableRow>
        ))
    }

    return (
        <Paper className={classes.tableWrapper}>
            <div className={classes.tableSection}>
                <EnhancedTableToolbar />
                <TableContainer>
                    <Table
                        className={classes.table}
                        aria-labelledby='tableTitle'
                        aria-label='enhanced table'>
                        <TableHead className={globalClasses.tableHeader}>
                            <TableRow>
                                {headCells.map((headCell, index) => (
                                    <TableCell key={'head-cell-' + index}>
                                        {headCell.label}
                                    </TableCell>
                                ))}
                                <TableCell />
                            </TableRow>
                        </TableHead>
                        <TableBody>{getTableContent()}</TableBody>
                    </Table>
                </TableContainer>
            </div>

            {createAccessLevelModalOpen && (
                <CreatePermissionGroupModal
                    userRoles={userRoles}
                    data-testid='create-permission-group-modal'
                    setModalOpen={isOpen =>
                        setCreatePermissionGroupModalOpen(isOpen)
                    }
                    okMethod={createPermissionGroupModalOkClickHandler}
                />
            )}
        </Paper>
    )
}

export default UserPermissionGroups
